const upgrade = {
  pricingTitle: 'Choose Plan',
  pricingSubtitle:
    'Choose the plan that fits your hiring pace with AI-powered recruiting and matching.',
  upgradeNow: 'Upgrade Now',
  pricingTabs: {
    pro: 'Individual',
    business: 'Enterprise',
  },
  billingCycles: {
    monthly: 'Monthly',
    semiannual: '6 months',
    annual: 'Yearly',
  },
  double11Title: 'Double 11 Special',
  double11Deadline: 'Ends Nov 11, 2026, 23:59 (UTC+8)',
  recommendedBadge: 'Recommended',
  highFrequencyBadge: 'Best for high-volume hiring',
  saveBadge: 'Double 11 Offer',
  pointsPackageTab: 'Credit packs',
  pointsPackageEmpty: 'No credit packs are available yet',
  pointsPackageDesc: 'Add contact credits when your membership needs extra capacity.',
  pointsPackageFallbackName: 'Credit pack',
  pointsPackageCredits: '{count} contact credits',
  pointsPackageCreditUnit: 'credit',
  pointsPackageBenefit: 'Credits will be granted after backend confirmation',
  pointsPackageOneTime: 'One-time purchase',
  pointsPackageVipRequired: 'Starter Pack or higher is required to buy credit packs',
  pointsPackageVipRequiredShort: 'Starter+ only',
  buyPointsPackage: 'Buy credit pack',
  vipOnlyBadge: 'Starter+ members only',
  pricingPlans: {
    starter: {
      name: 'Starter Pack',
      description: 'For lightweight recruiting and experiencing AI candidate matching',
      unit: 'USD / 30 days',
      dailyPrice: '$0.03 USD / day',
      actionText: 'Get Starter Pack',
      features: [
        '1,500 AI credits / 30 days',
        'Includes 1 seat',
        'Job conversations, talent sourcing & matching',
        'Email templates & bulk outreach',
        '0 contact credits',
      ],
      promotion: 'Starter exclusive · Once per user',
    },
    basic: {
      name: 'Starter Pack',
      description: 'For lightweight recruiting and experiencing AI candidate matching',
      unit: 'USD / 30 days',
      dailyPrice: '$0.03 USD / day',
      actionText: 'Get Starter Pack',
      features: [
        '1,500 AI credits / 30 days',
        'Includes 1 seat',
        'Job conversations, talent sourcing & matching',
        'Email templates & bulk outreach',
        '0 contact credits',
      ],
    },
    professional: {
      name: 'Professional',
      description: 'Designed for professional recruiters and active hiring teams',
      badge: 'Double 11 Pick',
      unit: 'USD / mo',
      dailyPrice: '$1.30 USD / day',
      actionText: 'Upgrade to Professional',
      features: [
        '14,000 AI credits / month',
        'Includes 1 seat',
        'Job conversations, talent sourcing & matching',
        'Email templates & bulk outreach',
        '20 contact credits / month',
      ],
      promotion: 'About 34% off · Save $20',
    },
    professionalAnnual: {
      name: 'Professional',
      description: 'Designed for professional recruiters and active hiring teams',
      badge: 'Double 11 Pick',
      unit: 'USD / yr',
      dailyPrice: '$48.17 USD / mo · Save $102 on the annual price',
      actionText: 'Upgrade to Professional',
      features: [
        '168,000 AI credits / year (14,000 / mo)',
        'Includes 1 seat',
        'Job conversations, talent sourcing & matching',
        'Email templates & bulk outreach',
        '240 contact credits / year (20 / mo)',
      ],
      promotion: '15% off annual · Save $102',
    },
    professionalPro: {
      name: 'Professional Pro',
      description: 'For high-frequency recruiting and advanced AI matching',
      badge: 'Best for high-volume hiring',
      unit: 'USD / mo',
      dailyPrice: '$2.63 USD / day',
      actionText: 'Upgrade to Professional Pro',
      features: [
        '26,500 AI credits / month',
        'Includes 1 seat',
        'Job conversations, talent sourcing & matching',
        'Email templates & bulk outreach',
        '45 contact credits / month',
      ],
    },
    professionalSemiannual: {
      name: 'Professional Semiannual',
      description: 'For ongoing hiring with one 6-month payment',
      badge: '6-month plan',
      unit: 'USD / 6 mo',
      dailyPrice: '$1.90 USD / day',
      actionText: 'Pay now',
      features: [
        '180 days of membership',
        '84,000 AI credits',
        'Includes 1 seat',
        'Job conversations, talent sourcing & matching',
        'Email templates & bulk outreach',
        '120 contact credits',
      ],
    },
    professionalProSemiannual: {
      name: 'Professional Pro Semiannual',
      description: 'For high-volume hiring with one 6-month payment',
      badge: '6-month plan',
      unit: 'USD / 6 mo',
      dailyPrice: '$2.63 USD / day',
      actionText: 'Pay now',
      features: [
        '180 days of membership',
        '159,000 AI credits',
        'Includes 1 seat',
        'Job conversations, talent sourcing & matching',
        'Email templates & bulk outreach',
        '270 contact credits',
      ],
    },
    professionalProAnnual: {
      name: 'Professional Pro Annual',
      description: 'For large-scale recruiting with one annual payment',
      badge: 'Annual plan',
      unit: 'USD / yr',
      dailyPrice: '$2.59 USD / day',
      actionText: 'Pay now',
      features: [
        '365 days of membership',
        '318,000 AI credits',
        'Includes 1 seat',
        'Job conversations, talent sourcing & matching',
        'Email templates & bulk outreach',
        '540 contact credits',
      ],
    },
    enterpriseStandardMonthly: {
      name: 'Enterprise',
      description: 'Monthly reference price, billed annually',
      unit: 'USD / mo',
      dailyPrice: '$6.63 USD / day',
      actionText: 'Billed annually',
      features: [
        '30,000 AI credits / month',
        'Includes 2 seats (1+1)',
        'Job conversations, talent sourcing & matching',
        'Email templates & bulk outreach',
        'Bulk AI InMail',
        'Talent pool & job candidate Excel export',
        '45 contact credits / month',
      ],
    },
    enterpriseGrowthMonthly: {
      name: 'Enterprise Growth',
      description: 'Monthly reference price, billed annually',
      badge: 'Recommended',
      unit: 'USD / mo',
      dailyPrice: '$9.97 USD / day',
      actionText: 'Billed annually',
      features: [
        '45,000 AI credits / month',
        'Includes 4 seats (1+3)',
        'Job conversations, talent sourcing & matching',
        'Email templates & bulk outreach',
        'Bulk AI InMail',
        'Talent pool & job candidate Excel export',
        '120 contact credits / month',
      ],
    },
    enterpriseStandardSemiannual: {
      name: 'Enterprise Semiannual',
      description: 'For growing recruiting teams with one 6-month payment',
      unit: 'USD / 6 mo',
      dailyPrice: '$6.63 USD / day',
      actionText: 'Pay now',
      features: [
        '180,000 AI credits / 6 mo',
        'Includes 2 seats (1+1)',
        'Job conversations, talent sourcing & matching',
        'Email templates & bulk outreach',
        'Bulk AI InMail',
        'Talent pool & job candidate Excel export',
        '270 contact credits / 6 mo',
      ],
    },
    enterpriseGrowthSemiannual: {
      name: 'Enterprise Growth Semiannual',
      description: 'For high-growth companies with one 6-month payment',
      badge: 'Recommended',
      unit: 'USD / 6 mo',
      dailyPrice: '$9.97 USD / day',
      actionText: 'Pay now',
      features: [
        '270,000 AI credits / 6 mo',
        'Includes 4 seats (1+3)',
        'Job conversations, talent sourcing & matching',
        'Email templates & bulk outreach',
        'Bulk AI InMail',
        'Talent pool & job candidate Excel export',
        '720 contact credits / 6 mo',
      ],
    },
    enterpriseStandardAnnual: {
      name: 'Enterprise',
      description: 'Tailored for growing hiring teams with comprehensive capabilities',
      unit: 'USD / yr',
      dailyPrice: '$179.17 USD / mo',
      actionText: 'Pay now',
      features: [
        '360,000 AI credits / year',
        'Includes 2 seats (1+1)',
        'Job conversations, talent sourcing & matching',
        'Email templates & bulk outreach',
        'Bulk AI InMail',
        'Talent pool & job candidate Excel export',
        '540 contact credits / year',
      ],
      promotion: 'About 10% off annual plans',
    },
    enterpriseGrowthAnnual: {
      name: 'Enterprise Growth',
      description: 'Built for high-growth enterprises and large recruitment operations',
      badge: 'Recommended',
      unit: 'USD / yr',
      dailyPrice: '$269.17 USD / mo',
      actionText: 'Pay now',
      features: [
        '540,000 AI credits / year',
        'Includes 4 seats (1+3)',
        'Job conversations, talent sourcing & matching',
        'Email templates & bulk outreach',
        'Bulk AI InMail',
        'Talent pool & job candidate Excel export',
        '1,440 contact credits / year',
      ],
      promotion: 'About 10% off annual plans',
    },
    contactPoints10: {
      name: '10 Contact Credits',
      description: 'Contact credit pack. Members only.',
      unit: 'USD',
      unitPrice: '$0.70 USD / credit',
      actionText: 'Buy credit pack',
    },
    contactPoints30: {
      name: '30 Contact Credits',
      description: 'Contact credit pack. Members only.',
      unit: 'USD',
      unitPrice: '$0.60 USD / credit',
      actionText: 'Buy credit pack',
    },
    contactPoints100: {
      name: '100 Contact Credits',
      description: 'Contact credit pack. Members only.',
      unit: 'USD',
      unitPrice: '$0.57 USD / credit',
      actionText: 'Buy credit pack',
    },
    contactPoints300: {
      name: '300 Contact Credits',
      description: 'Contact credit pack. Members only.',
      unit: 'USD',
      unitPrice: '$0.57 USD / credit',
      actionText: 'Buy credit pack',
    },
    contactPoints1000: {
      name: '1,000 Contact Credits',
      description: 'Contact credit pack. Members only.',
      unit: 'USD',
      unitPrice: '$0.57 USD / credit',
      actionText: 'Buy credit pack',
    },
  },
  trialDaysBadge: '{days}-day trial',
  autoRenewBadge: 'Auto-renewal',
  startTrial: 'Start trial',
  currentPlanAction: 'Current plan',
  lowerPlanAction: 'Included in current plan',
  upgradeToPlan: 'Upgrade to {planName}',
  activeMembershipExists: 'You are already on {planName} or a higher plan',
  paymentReturn: {
    checking: {
      title: 'Confirming payment result',
      desc: 'You have returned to EasyHireAI. We are refreshing the order, subscription, and current benefits.',
    },
    success: {
      title: 'Payment confirmed',
      desc: 'The backend has confirmed the payment result. The latest benefits are shown below.',
    },
    pending: {
      title: 'Payment is still pending',
      desc: 'The Waffo webhook may take a moment. This is not treated as a failure. Refresh later or check your profile.',
    },
    failed: {
      title: 'Payment was not completed',
      desc: 'The backend returned an incomplete payment status. Please retry payment or contact support.',
    },
    refresh: 'Refresh result',
    planLabel: 'Item',
    orderLabel: 'Order ID',
    assets: {
      contact: 'Contact credits',
      aiMatch: 'AI Credits',
      jobs: 'Jobs',
      membership: 'Membership',
    },
    membershipStatus: {
      active: 'Active subscription',
      trialing: 'Trialing',
      canceling: 'Auto-renewal cancelled',
      canceled: 'Membership ended',
      past_due: 'Renewal failed',
      expired: 'Expired',
      none: 'Not active',
    },
  },
  subscriptionAiMatchBenefit: '{count} AI Credits',
  subscriptionJobCountBenefit: 'Manage up to {count} jobs',
  subscriptionMembershipBenefit: 'Membership benefits included',
  subscriptionFallbackName: 'Subscription plan',
  subscriptionPlanDesc: 'Renews automatically on the selected billing cycle',
  productBenefits: {
    membershipDays: '{count} days of membership',
    aiMatch: '{count} AI credits',
    enterpriseAiCredits: '{count} AI credits',
    enterpriseAiCreditsMonthly: '{count} AI credits / month',
    jobs: 'Manage up to {count} jobs',
    unlimitedJobs: 'Unlimited jobs',
    contactPoints: '{count} contact credits',
    contactPointsMonthly: '{count} contact credits / month',
    noContactPoints: '0 contact credits',
    agentConversations: '{count} Agent conversations',
    seats: 'Includes {count} seats',
  },
  cancelAutoRenew: 'Cancel auto-renewal',
  cancelAutoRenewTitle: 'Cancel auto-renewal',
  cancelAutoRenewDesc:
    'After cancellation, your current membership remains active until {date}. You will not be charged again.',
  cancelAutoRenewConfirm: 'Confirm cancellation',
  cancelAutoRenewSuccess: 'Auto-renewal has been cancelled',
  cancelAutoRenewFailed: 'Failed to cancel auto-renewal. Please try again later.',
  subscriptionCheckoutDesc:
    'Waffo checkout will open to complete the subscription. Once active, it renews automatically on the selected billing cycle.',
  membershipRequired: {
    toast: 'An active membership is required. Please subscribe before purchasing credit packs.',
  },
  membershipRequiredTitle: 'Membership required',
  goToMembership: 'View plans',
  chinaIdentityFilterPrompt:
    'Chinese identity and China-company experience are members-only filters. Subscribe to use them.',
  aiMatchMembershipPrompt:
    'AI Credits are insufficient. Subscribe or upgrade to continue viewing resume scores.',
  agentOpenJobMembershipPrompt:
    'AI Agent recruiting requires an active membership. Renew now to keep your remaining credits.',
  sales: {
    moreFeatures: 'Need more capabilities for your organization?',
    businessCta: 'Talk to Sales',
    businessCardTitle: 'Custom Enterprise',
    businessCardDesc: 'For organizations that need more seats, capacity, or dedicated support',
    businessCardPrice: 'Custom pricing',
    businessCardFeatures: [
      'Flexible AI and contact credit capacity',
      'Additional team seats and permission controls',
      'Tailored solutions with 1-on-1 enterprise support',
      'Custom API integration and data privacy guarantees',
    ],
    dialogTitle: 'Contact Sales',
    qrAlt: 'Contact sales QR code',
    customPlanHint: 'Scan to contact sales for a tailored plan and quote.',
    invoiceNote:
      "Invoice process: WeChat Pay users should send invoice details, account, and amount to chris{'@'}easyhireai.com. Replies are handled every Friday.",
  },
  ctaTitle: 'VIP Membership Expired',
  ctaDesc: 'Unlock more VIP benefits',
  ctaAction: 'Upgrade Now',
  dialogTitle: 'Choose the plan that fits your hiring pace.',
  suppressToday: "Don't show again today",
  currentMembership: 'Current membership:',
  vipMember: 'VIP member',
  nonMember: 'No active membership',
  trialMember: 'Trial member',
  trialDuration: 'Trial length {days} days',
  trialExpired: 'Expired',
  singlePurchaseLimit: 'Limit one per user',
  popularBadge: 'Most Popular',
  planLabel: 'Plan highlights',
  contactSales: 'Contact Sales',
  salesQrHint: 'Scan to contact sales',
  choosePlan: 'Choose Plan',
  contactSalesCustom: 'Contact Sales',
  paymentTitle: 'Scan to pay and use the remark code',
  paymentDesc:
    'After the order is created, payment updates will stream in and refresh your membership once paid.',
  paymentWarning:
    'When paying, please enter this purchase code in the payment remark:\n[{code}]\n(Used to confirm your order. Otherwise, manual processing is required.)\nAfter payment succeeds, your top-up is expected to be completed within 10 minutes.',
  paymentPlaceholder: 'Generating payment QR...',
  paymentCodeLabel: 'Purchase code',
  paymentOrderLabel: 'Order ID',
  paymentExpireLabel: 'Expires at',
  paymentCopyCode: 'Copy code',
  paymentRefresh: 'Refresh status',
  paymentCancel: 'Cancel order',
  deadlineNoticeEyebrow: 'Official Plans Updated',
  deadlineNoticeTitle: 'EasyHireAI official pricing is now live',
  deadlineNoticeSubtitle: 'Choose the plan that fits your hiring rhythm.',
  deadlineNoticeDesc:
    'The in-app plans read product data from the API in real time. Prices, benefits, and purchase actions follow the current product configuration.',
  contactSalesStageTitle: 'Contact Sales for a Custom Plan',
  contactSalesStageHint: 'Scan to contact sales for a tailored quote and solution.',
  contactSalesClose: 'Back to Plans',
  productsLoadingTitle: 'Loading plan details',
  productsLoadingDesc:
    'Please wait. We will continue automatically once the product data is ready.',
  createOrderFailed: 'Failed to create the order. Please try again.',
  purchaseLimitExceeded:
    'You have reached the purchase limit for this product. The product list has been refreshed.',
  paymentSuccessMessage: 'Payment succeeded. Your membership status has been updated.',
  paymentSuccessTitle: 'Payment Success',
  contactSalesStageDesc:
    '{planName} requires sales assistance. We have prepared the contact QR for you.',
  planProductMissing: 'This plan does not have a payment product configured yet',
  planProductPendingAction: 'Payment pending',
  semiannualMinimumAction: 'Annual billing',
  planDisplayOnlyAction: 'Display only',
  planDisplayOnlyReason: 'Reference price only. Switch to annual billing to purchase.',
  confirmPurchaseMessage:
    'Confirm purchase of {planName}? A payment order will be created after confirmation.',
  confirmPurchaseTitle: 'Confirm Purchase',
  orderFailedTitle: 'Order Failed',
  codeCopied: 'Code copied',
  paymentChannelLabel: 'Payment method',
  channelWecom: 'WeChat Pay',
  channelWaffo: 'Waffo Pay',
  payByWecom: 'WeChat Pay',
  payByWaffo: 'Pay now',
  paymentMethodDialogTitle: 'Choose payment method',
  paymentMethodDialogDesc:
    'Choose a payment method. After WeChat payment is confirmed by the back office, membership benefits will refresh automatically.',
  wechatPaymentTitle: 'WeChat Pay',
  wechatPaymentWaitingHint:
    'Enter the 4-digit payment code in the WeChat payment remark. Benefits will be applied automatically after admin confirmation.',
  wechatPaymentCodeLabel: 'Payment remark code',
  wechatPaymentExpiredHint: 'The order was not completed or has expired. Please start again.',
  wechatPaymentQrMissing: 'Could not load the WeChat payment QR. Please try again later.',
  waffoPaymentTitle: 'Complete payment on Waffo',
  waffoPaymentDesc:
    'Click the button below to open the Waffo checkout. Your membership will refresh automatically once paid.',
  waffoRedirectHint:
    'Redirecting to the Waffo checkout. Please complete the payment on the next page.',
  waffoOpenCheckout: 'Go to Waffo checkout',
  waffoPendingHint:
    'Payment status will be confirmed automatically when you return. Please keep this window open.',
  paymentInProgressTitle: 'Payment in progress',
  paymentInProgressMessage:
    'An order is currently being processed. Leaving may lose the payment state. Continue?',
  paymentInProgressConfirm: 'Leave',
  enterpriseFeature: {
    title: 'Enterprise Exclusive Feature',
    description:
      'This feature is exclusive to Enterprise plans. Please contact our sales team to enable it.',
    featureDescription:
      '"{feature}" is exclusive to Enterprise plans. Please contact our sales team to enable it.',
    contactSales: 'Contact Sales',
    scanQrHint: 'Scan QR code to contact your sales consultant via WeChat',
    emailContactHint: 'Contact our sales team directly via email:',
    copyEmail: 'Copy Email',
    copiedEmail: 'Email copied to clipboard',
    sendEmail: 'Send Email',
    viewPlans: 'View Enterprise Plans',
  },
  pricingBenefitsLabel: 'Membership benefits',
  pricingContactCreditsLabel: 'Contact credits',
  pricingFitForLabel: 'Best for',
}

export default upgrade
